/*** IMPORTS FROM imports-loader ***/
var define = false;

'use strict';

export default typeof FormData !== 'undefined' ? FormData : null;

